// Selectors.
import Selectors from '../../selectors.js';

// Config.
import Config from '../../config/config.js';

/**
 * Position business logic.
 *
 * @namespace
 *
 * @memberof module:Overlay.Model.Logic
 */
const Position = {
  /**
   * Calculate initial pageInfo object if not already set
   *
   */
  calculatePageInfo: function() {
    // Calculate page info.
    const pageInfo = {
      clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
      scrollTop:
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (document.documentElement || document.body.parentNode || document.body).scrollTop,
      offsetTop: 0,
    };

    return pageInfo;
  },

  /**
   * Calculate vertical center position of overlay.
   *
   */
  calculateVerticalCenter: function(overlayInner, info) {
    // Get Config service.
    const configService = NGXD.getServiceContainer().getService('config');

    // Get State service.
    const stateService = NGXD.getServiceContainer().getService('state');

    // Get Api service.
    const apiService = NGXD.getServiceContainer().getService('api');

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    var _info = info || {};

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // If preview mode, we also need to take into account the scrollY off the fixed height wrapper div (not the actual window, this never scrolls!).
    if (configService.get('preview.isPreview')) {
      try {
        const parentWinDoc = window.parent.document;
        const previewDiv = parentWinDoc.querySelector('.wyn-page-designer__preview');
        _info.scrollTop = previewDiv.scrollTop;

        // Need to account for the mobile previews that might be centered vertically.
        _info.offsetTop = Math.max(
          previewDiv.offsetTop,
          parentWinDoc.querySelector('.wyn-page-designer__preview iframe').offsetTop
        );
        _info.clientHeight = window.parent.innerHeight;
      } catch (exception) {}
    }

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // Get various dimensions of overlay and page.
    var st = _info.scrollTop,
      ch = _info.clientHeight,
      iframeH = $(overlayInner).outerHeight(), // iframe height
      viewportH = _info.innerHeight, // viewport height
      ot = _info.offsetTop, // height from top of parent page to top of iframe
      total;

    var vTop, vMiddle, vBottom;

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // If we are framed.
    if (stateService.get('window.framed')) {
      vTop = st;
      vBottom = vTop + viewportH;
      vMiddle = (vBottom - vTop) / 2 + vTop;
      total = vMiddle - iframeH / 2 - ot;
      var docHeight = $(document).outerHeight();

      // If the iframe is smaller than the content, you're gonna have to try to grow it
      if (iframeH > docHeight) {
        document.body.style.minHeight = iframeH + 40 + 'px';
        apiService.execute('resizeParent');
        total = 0;
      }
      // If the bottom of the iframe would be cut off, move to top of frame
      if (total > docHeight || total + iframeH > docHeight) {
        total = docHeight - (iframeH + 40);
      }

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Otherwise if we are not framed.
    } else {
      // in this case, iframeH is just the size of the overlay background.
      total = ch / 2 - iframeH / 2;
    }

    // Round top value.
    const top = Math.max(10, Math.round(total));

    return top;
  },

  resetMinHeight: function() {
    const stateService = NGXD.getServiceContainer().getService('state');
    if (stateService.get('window.framed') && !!document.body.style && !!document.body.style.minHeight) {
      document.body.style.minHeight = '';
    }
  },
};

export default Position;
